import ColumnsWithImages from "./ColumnsWithImages";

export default ColumnsWithImages;
